import {create} from './create';

export const storageProxy = create();
